import {styled} from '../../../utils';
import {placeholder} from 'polished';
import {TextFieldProps} from '../types';

interface TextFieldInputProps
  extends Pick<TextFieldProps, 'small' | 'large' | 'disabled' | 'icon' | 'iconPosition' | 'multiline'> {}

export default styled('input')<TextFieldInputProps>(
  ({theme}) => ({
    fontFamily: theme.fontFamily.base,
    color: '#1B202A',
    boxSizing: 'border-box',
    margin: 0,
    border: `1px solid ${theme.textField.borderColor.base}`,
    borderRadius: theme.textField.borderRadius,
    width: '100%',
    transition: 'all 0.3s',
    position: 'relative',
    '&:hover': {
      borderColor: theme.textField.borderColor.hover
    },
    '&:focus': {
      borderColor: theme.textField.borderColor.focus,
      outline: 0
    },
    ...placeholder({color: '#bfbfbf', opacity: 1})
  }),
  ({small, large, icon, iconPosition, theme}) => {
    const size = small ? 'small' : large ? 'large' : 'base';

    const fontSize = theme.textField.fontSize[size];
    const height = theme.textField.height[size];

    let paddingLeft = theme.textField.paddingX[size];
    let paddingRight = theme.textField.paddingX[size];

    if (icon && iconPosition === 'start') {
      paddingLeft = theme.textField.paddingXWithIconOffset[size];
    }

    if (icon && iconPosition === 'end') {
      paddingRight = theme.textField.paddingXWithIconOffset[size];
    }

    return {
      fontSize,
      height,
      paddingLeft,
      paddingRight
    };
  },
  ({multiline, small, large, theme}) => {
    const size = small ? 'small' : large ? 'large' : 'base';

    if (multiline) {
      return {
        height: undefined,
        minHeight: 140,
        paddingTop: theme.textField.multilinePaddingY[size],
        paddingBottom: theme.textField.multilinePaddingY[size]
      };
    }
    return {};
  }
);



// WEBPACK FOOTER //
// ./src/components/TextField/private/TextFieldInput.tsx